"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rejectPriceListSchema = exports.createPriceListSchema = exports.priceListShape = exports.priceListLineSchema = exports.priceListLineShape = exports.PRICE_LIST_TYPES = void 0;
const zod_1 = require("zod");
exports.PRICE_LIST_TYPES = [
    'STANDARD',
    'RETAIL',
    'HOSPITAL',
    'CORPORATE',
    'INSURANCE',
    'EMPLOYEE',
    'CHARITY',
    'GOVERNMENT_SCHEME',
    'CAMP',
    'WHOLESALE',
];
exports.priceListLineShape = {
    drugId: zod_1.z.string().uuid().optional(),
    itemId: zod_1.z.string().uuid().optional(),
    sellingPrice: zod_1.z.number().int().nonnegative(),
    mrp: zod_1.z.number().int().nonnegative(),
    purchaseCostSnapshot: zod_1.z.number().int().nonnegative().optional(),
    gstPercent: zod_1.z.number().min(0).max(100).optional(),
    cessPercent: zod_1.z.number().min(0).max(100).optional(),
    discountAllowed: zod_1.z.boolean().optional(),
    maxDiscountPercent: zod_1.z.number().min(0).max(100).optional(),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().optional(),
};
exports.priceListLineSchema = zod_1.z.object(exports.priceListLineShape);
exports.priceListShape = {
    name: zod_1.z.string().min(1).max(255),
    listType: zod_1.z.enum(exports.PRICE_LIST_TYPES),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().optional(),
    remarks: zod_1.z.string().optional(),
};
exports.createPriceListSchema = zod_1.z.object({
    ...exports.priceListShape,
    lines: zod_1.z.array(exports.priceListLineSchema).min(1),
});
exports.rejectPriceListSchema = zod_1.z.object({ reason: zod_1.z.string().min(1) });
//# sourceMappingURL=price-list.schema.js.map